import { Mid } from "@mid/sdk";
import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";

// import config from "../../config/config";
import Loader from "../loader/login-loader";

import LandingPage from "./landing-page";

interface LoginComponentProps {
    mid?: Mid;
    children?: React.ReactNode;
    "data-testid"?: string;
}

const LoginComponent: React.FC<LoginComponentProps> = ({ mid, children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
    const [hasCheckedAuth, setHasCheckedAuth] = useState<boolean>(false);

    // const navigate = useNavigate();

    useEffect(() => {
        if (mid && !hasCheckedAuth) {
            mid.isAuthed().then((status) => {
                setIsAuthenticated(status);
                setHasCheckedAuth(true);
            });
        } else if (mid) {
            mid.isAuthed().then(setIsAuthenticated);
        }
    }, [mid, hasCheckedAuth]);

    const adaptedMid = mid
        ? {
              accessToken: () => mid.accessToken() || "",
              isAuthed: () => isAuthenticated,
              login: () => {
                  mid.login().then(() => {
                      mid.isAuthed().then((status) => {
                          setIsAuthenticated(status);
                      });
                  });
              },
          }
        : undefined;

    if (!hasCheckedAuth) {
        return <Loader blur={true} />;
    }

    return <div>{adaptedMid ? <LandingPage mid={adaptedMid}>{children}</LandingPage> : children}</div>;
};

export default LoginComponent;
